// extracted by mini-css-extract-plugin
module.exports = {"container":"_1f4mL","share-icons":"_3hewT","shareIcons":"_3hewT","share-icon":"WHo0y","shareIcon":"WHo0y"};